import { updateSidePaneType } from 'owa-calendar-compose-form-actions';
import SidePaneType from 'owa-calendar-sidepane/lib/schema/SidePaneType';
import toggleExpressionSidePane from 'owa-expressions-store/lib/actions/toggleExpressionSidePane';
import { orchestrator } from 'satcheljs';

export default orchestrator(toggleExpressionSidePane, actionMessage => {
    const { showExpressionPane } = actionMessage;

    updateSidePaneType(
        null /* formId */,
        showExpressionPane ? SidePaneType.EmojiPicker : SidePaneType.None
    );
});
